import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ShareProductButton from "./ShareProductButton";
import WhatsAppProductButton from "./WhatsAppProductButton";
import ProductPriceDisplay, { ProductDiscountBadge } from "./ProductPriceDisplay";
import { EC } from "../../utils/const/ecommerce-colors-const";
import { getProductPricing, getPriceLocale, formatProductPrice } from "../../utils/ecommerce/product-pricing";
import { scrollToTop } from "../../utils/ecommerce/scroll-to-top";

export default function ProductCard({ product, compact = false, onProductClick }) {
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const name = product.nombre;
    const categoryLabel = t(`${product.categoriaProducto}`);
    let coverImage = null;
    if (product.imagenPrincipal === null || String(product.imagenPrincipal).trim().length === 0) {
        coverImage = product.imagenes[0];
    } else {
        coverImage = product.imagenPrincipal;
    }
    const pricing = getProductPricing(product);

    const goToDetail = () => {
        // onProductClick?.();
        scrollToTop();
        history.push(`/detalle-producto/${product.id}`);
    };

    return (
        <article
            className={`group flex flex-col overflow-hidden ${EC.card.base} ${EC.card.hover} ${compact ? "" : "h-full"
                }`}
        >
            <button
                type="button"
                onClick={goToDetail}
                className="relative block w-full overflow-hidden bg-slate-100 text-left"
            >
                <div className={`relative w-full ${compact ? "aspect-[4/3]" : "aspect-square sm:aspect-[4/3]"}`}>
                    <img
                        src={coverImage}
                        alt={name}
                        className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
                        loading="lazy"
                    />
                    {product.badge && (
                        <span
                            className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white shadow-md ${product.badge === "new" ? EC.badge.new : EC.badge.hotPulse
                                }`}
                        >
                            {t(`${product.badge}`)}
                        </span>
                    )}
                    <ProductDiscountBadge product={product} />
                    {(product.imagenes?.length ?? 0) > 1 && (
                        <span className="absolute bottom-3 right-3 rounded-lg bg-black/50 px-2 py-1 text-xs font-medium text-white backdrop-blur-sm">
                            +{(product.imagenes?.length ?? 1) - 1} {t("ct_more_photos")}
                        </span>
                    )}
                </div>
            </button>

            <div className="flex flex-1 flex-col p-4 sm:p-5">
                <div className="mb-2 flex items-start justify-between gap-2">
                    <span className={EC.chip.category}>{categoryLabel}</span>
                    {product.rating && (
                        <span className={EC.rating.textSm}>★ {product.rating}</span>
                    )}
                </div>

                <button type="button" onClick={goToDetail} className="text-left">
                    <h3 className={`line-clamp-2 text-base font-bold text-slate-900 transition ${EC.card.titleHover} sm:text-lg`}>
                        {name}
                    </h3>
                </button>

                <div className="mt-2">
                    <ProductPriceDisplay product={product} size={compact ? "md" : "md"} />
                </div>

                {pricing.isOnSale && (
                    <p className="mt-1 text-xs font-medium text-ct-price-600">
                        {t("ct_you_save")}{" "}
                        {formatProductPrice(
                            pricing.precioOriginal - pricing.salePrice,
                            product.abreviatura,
                            getPriceLocale(i18n.language)
                        )}
                    </p>
                )}

                <div className="mt-auto flex flex-col gap-2 pt-4 xs:flex-row xs:flex-wrap xs:items-center">
                    <button type="button" onClick={goToDetail} className={`${EC.btn.outline} w-full xs:w-auto xs:flex-1`}>
                        {t("ct_view_details")}
                    </button>
                    {/* <AddToCartButton product={product} compact className="w-full xs:flex-1" /> */}
                    <WhatsAppProductButton
                        telefonoEmpresa={product.telefonoEmpresa}
                        productId={product.id}
                        productName={name}
                        compact
                        className="self-end xs:self-auto"
                    />
                    <ShareProductButton productId={product.id} compact className="self-end xs:self-auto" />
                </div>
            </div>
        </article>
    );
}
